export const environmentIa = {
    production: true,
    apiUrl: 'http://localhost:3000',
    apiUrlProd: 'https://ia-service.ingresoweb.com.ar',
    version: '1.0.0',
    appName: 'IA RP',
};
